import React, {useEffect} from "react";
import "react-phone-input-2";
import {generateEvent} from "../../../utils";
import PhoneInput from "react-phone-input-2";
import {useTranslation} from "react-i18next";
import {useController} from "react-hook-form";
import ru from "react-phone-input-2/lang/ru.json";
import "./ARPhoneInput.scss";

const ARPhoneInput = (props) => {
  const {id, name, block, control, customContainerClass, setError, customInputClass, ...inputProps} = props;
  const {i18n} = useTranslation();
  const {field, fieldState, formState} = useController({
    name,
    control,
    shouldUnregister: true
  });

  const {onChange, onBlur, ref, value, ...reg} = field;
  const {invalid, error, isDirty} = fieldState;
  const {isSubmitted} = formState;

  useEffect(() => {
    setError && setError(error);
  }, [setError, error]);

  const changeHandler = (value, countryCode, event) => {
    const newEvent = generateEvent({event, newValue: value});

    onChange(newEvent);
  };

  const blurHandler = () => {
    onBlur && onBlur();
  };

  const valid = (isDirty || isSubmitted) && !error;


  const validationClass = invalid ? "is-invalid" : valid ? "is-valid" : "";
  const blockClass = block ? "w-100" : "";

  return (
    <PhoneInput
      key={i18n.language}
      localization={i18n.language === "ru" ? ru : undefined}
      containerClass={["flags-container", validationClass, blockClass, customContainerClass].join(" ")}
      inputClass={[validationClass, customInputClass].join(" ")}
      inputProps={{...inputProps, ...reg, id}}
      country="ru"
      value={value}
      jumpCursorToEnd={false}
      numberInputRef={ref}
      onChange={changeHandler}
      onBlur={blurHandler}
    />
  );
};

ARPhoneInput.defaultProps = {
  customContainerClass: "",
  customInputClass: "",
};

export default ARPhoneInput;